"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteEntityTypeT = exports.NoteEntityType = exports.MetaT = exports.MetaSettingT = exports.SubRosterMasterT = exports.LinkedRosterT = exports.LeaveT = exports.JobT = exports.IgnoredUnavailabilityT = exports.GridExceptions = exports.EmployeeCertificationT = exports.EmployeeT = exports.TCLinkT = exports.EmployeeDetailT = exports.DeletedShiftT = exports.CostCentreT = exports.AttributeRequirementT = exports.AttributePosT = exports.AttributeT = exports.CompatibilityT = exports.CompanyT = exports.ClockingT = exports.ClientT = exports.ClientLeaveT = exports.ClientGroupT = exports.ClientEventT = exports.ClassificationT = exports.ChargeGroupT = exports.CertificationT = exports.CCCFilterT = exports.CancellationReasonT = exports.AreaT = exports.AllowanceT = exports.AllowCriteriaT = exports.AllowanceTypeT = exports.EmployeeCompetencyT = exports.ViewGroupByT = exports.ViewGroupBy = exports.ViewColorByT = exports.ViewColorBy = exports.ServiceCancellationTypeT = exports.ServiceCancellationType = exports.ShiftCancellationTypeT = exports.ShiftCancellationType = exports.JobPayTypeT = exports.JobPayType = exports.DayNumbersT = exports.DayNumbersArray = exports.StructureShiftT = exports.StructureLabelT = void 0;
exports.ViewT = exports.ViewModelT = exports.TakenT = exports.WarningT = exports.VerificationT = exports.UnavailabilityPresetT = exports.UnavailabilityModelT = exports.UnavailabilityRecordT = exports.UnavailabilityBlockT = exports.TimeClockSerialT = exports.TemplateT = exports.SMSHistoryT = exports.SMSAssignT = exports.SMST = exports.ShiftT = exports.ShiftLocationT = exports.ShiftTagT = exports.ShiftQueryT = exports.ShiftGapT = exports.ServiceScheduleLogT = exports.ServiceScheduledT = exports.ServiceRequestT = exports.ServiceFeedbackT = exports.ServiceCancellationT = exports.ServiceTypeT = exports.ServiceTypeAllowanceT = exports.ServiceT = exports.ScheduledLeaveT = exports.SCHADSGroupT = exports.RosterT = exports.RosterJobT = exports.RosterEmployeeT = exports.RosterClientT = exports.ResidentAdmissionRosterT = exports.QFRSettingsT = exports.QFRDynamicFieldT = exports.QFRCateringKeysT = exports.QFRAlliedHealthKeysT = exports.QFRDirectCareKeysT = exports.QFRSettingsKeysT = exports.QFRSettingBaseT = exports.QFRExceptionT = exports.QualifierT = exports.ProgramT = exports.PlaceT = exports.PeriodT = exports.CurrentPeriodT = exports.PendingUnavailabilityT = exports.NoteTypeT = exports.NoteT = void 0;
exports.ServerDataModelT = exports.DataModelT = exports.RosterMetaDataT = void 0;
const universal_1 = require("../universal");
const dates_1 = require("./dates");
exports.StructureLabelT = universal_1.t.Union([
    universal_1.t.Literal('j'),
    universal_1.t.Literal('e'),
    universal_1.t.Literal('c'),
    universal_1.t.Literal('rt'),
    universal_1.t.Literal('at'),
    universal_1.t.Literal('tg'),
]);
exports.StructureShiftT = universal_1.t.Union([
    universal_1.t.Literal('s'),
    universal_1.t.Literal('ss'),
    universal_1.t.Literal('x'),
    universal_1.t.Literal('t'),
]);
exports.DayNumbersArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
exports.DayNumbersT = universal_1.t.Union([
    universal_1.t.Literal(1),
    universal_1.t.Literal(2),
    universal_1.t.Literal(3),
    universal_1.t.Literal(4),
    universal_1.t.Literal(5),
    universal_1.t.Literal(6),
    universal_1.t.Literal(7),
    universal_1.t.Literal(8),
    universal_1.t.Literal(9),
    universal_1.t.Literal(10),
    universal_1.t.Literal(11),
    universal_1.t.Literal(12),
    universal_1.t.Literal(13),
    universal_1.t.Literal(14),
]);
var JobPayType;
(function (JobPayType) {
    JobPayType[JobPayType["PayByShift"] = 1] = "PayByShift";
    JobPayType[JobPayType["PayByTask"] = 2] = "PayByTask";
})(JobPayType || (exports.JobPayType = JobPayType = {}));
exports.JobPayTypeT = universal_1.t.Enum(JobPayType);
var ShiftCancellationType;
(function (ShiftCancellationType) {
    ShiftCancellationType[ShiftCancellationType["NotCancelled"] = 0] = "NotCancelled";
    ShiftCancellationType[ShiftCancellationType["CancelledUnpaid"] = 1] = "CancelledUnpaid";
    ShiftCancellationType[ShiftCancellationType["CancelledPaid"] = 2] = "CancelledPaid";
})(ShiftCancellationType || (exports.ShiftCancellationType = ShiftCancellationType = {}));
exports.ShiftCancellationTypeT = universal_1.t.Enum(ShiftCancellationType);
var ServiceCancellationType;
(function (ServiceCancellationType) {
    ServiceCancellationType[ServiceCancellationType["NotCancelled"] = 0] = "NotCancelled";
    ServiceCancellationType[ServiceCancellationType["CancelledCharged"] = 1] = "CancelledCharged";
    ServiceCancellationType[ServiceCancellationType["CancelledNotCharged"] = 2] = "CancelledNotCharged";
})(ServiceCancellationType || (exports.ServiceCancellationType = ServiceCancellationType = {}));
exports.ServiceCancellationTypeT = universal_1.t.Enum(ServiceCancellationType);
var ViewColorBy;
(function (ViewColorBy) {
    ViewColorBy[ViewColorBy["ShiftTemplate"] = 0] = "ShiftTemplate";
    ViewColorBy[ViewColorBy["Area"] = 1] = "Area";
    ViewColorBy[ViewColorBy["ServiceType"] = 2] = "ServiceType";
    ViewColorBy[ViewColorBy["ServiceAssigned"] = 3] = "ServiceAssigned";
    ViewColorBy[ViewColorBy["SCHADShiftGroup"] = 4] = "SCHADShiftGroup";
})(ViewColorBy || (exports.ViewColorBy = ViewColorBy = {}));
exports.ViewColorByT = universal_1.t.Enum(ViewColorBy);
var ViewGroupBy;
(function (ViewGroupBy) {
    ViewGroupBy[ViewGroupBy["NoGrouping"] = 0] = "NoGrouping";
    ViewGroupBy[ViewGroupBy["Area"] = 1] = "Area";
    ViewGroupBy[ViewGroupBy["Classification"] = 2] = "Classification";
    ViewGroupBy[ViewGroupBy["ShiftTemplate"] = 3] = "ShiftTemplate";
    ViewGroupBy[ViewGroupBy["ServiceType"] = 4] = "ServiceType";
})(ViewGroupBy || (exports.ViewGroupBy = ViewGroupBy = {}));
exports.ViewGroupByT = universal_1.t.Enum(ViewGroupBy);
exports.EmployeeCompetencyT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Competency: universal_1.t.Number(),
    Employee: universal_1.t.Number(),
    IssueDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    ExpiryDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    Notes: (0, universal_1.MaybeT)(universal_1.t.String()),
});
exports.AllowanceTypeT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
});
exports.AllowCriteriaT = universal_1.t.Object({
    AllowKey: universal_1.t.Number(),
    Automatic: universal_1.tBoolT,
    CasRate: universal_1.t.Number(),
    Criteria: universal_1.t.Number(),
    FreqName: universal_1.t.String(),
    Frequency: universal_1.t.Union([universal_1.t.Literal(1), universal_1.t.Literal(2), universal_1.t.Literal(3), universal_1.t.Literal(7)]),
    HasCasRate: universal_1.t.Boolean(),
    HasPermRate: universal_1.t.Boolean(),
    Name: universal_1.t.String(),
    PermRate: universal_1.t.Number(),
    PubHol: universal_1.tBoolT,
    RequireEdit: universal_1.tBoolT,
    RosterReimbursement: universal_1.tBoolT,
    RosterTravel: universal_1.tBoolT,
    Sat: universal_1.tBoolT,
    ServiceTravel: universal_1.tBoolT,
    Sex: universal_1.t.Union([universal_1.t.Literal('M'), universal_1.t.Literal('F'), universal_1.t.Null()]),
    ShiftLevel: universal_1.tBoolT,
    Sun: universal_1.tBoolT,
    WeekDay: universal_1.tBoolT,
});
exports.AllowanceT = universal_1.t.Array(exports.AllowCriteriaT);
exports.AreaT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Code: universal_1.t.String(),
    Color: (0, universal_1.MaybeT)(universal_1.t.String()),
    CostCentre: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Name: universal_1.t.String(),
    Sort: (0, universal_1.MaybeT)(universal_1.t.Number()),
});
exports.CancellationReasonT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Disabled: universal_1.tBoolT,
    Text: universal_1.t.String(),
});
exports.CCCFilterT = universal_1.t.Object({
    Companies: universal_1.t.Array(universal_1.t.Number()),
    CostCentres: universal_1.t.Array(universal_1.t.Number()),
});
exports.CertificationT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    ExpiryTime: universal_1.t.Number(),
    IsExpiryDate: universal_1.t.Boolean(),
    IsMedical: universal_1.t.Boolean(),
    IsCompulsory: universal_1.t.Boolean(),
});
exports.ChargeGroupT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Locations: universal_1.t.Array(universal_1.t.Number()),
    Name: universal_1.t.String(),
});
exports.ClassificationT = universal_1.t.Object({
    Active: universal_1.tBoolT,
    Award: universal_1.t.Number(),
    Code: universal_1.t.String(),
    Color: (0, universal_1.MaybeT)(universal_1.t.String()),
    DefaultCC: universal_1.t.Number(),
    GapAllowanceLength: universal_1.t.Number(),
    HoursForMeal: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    MaxBOWLength: universal_1.t.Number(),
    MinBOWLength: universal_1.t.Number(),
    MealLength: universal_1.t.Number(),
    Name: universal_1.t.String(),
    PrefName: universal_1.t.String(),
    ReplacementLinks: universal_1.t.Object({
        Classifications: universal_1.t.Array(universal_1.t.Number()),
        Employees: universal_1.t.Array(universal_1.t.Number()),
    }),
    RosterAccess: universal_1.t.Number(),
});
exports.ClientEventT = universal_1.t.Object({
    DefaultClients: universal_1.t.Array(universal_1.t.Number()),
    DefaultJobs: universal_1.t.Array(universal_1.t.Number()),
    Description: universal_1.t.String(),
    Finish: universal_1.t.String(),
    ID: universal_1.t.Number(),
    MaxClients: universal_1.t.Number(),
    MaxStaff: universal_1.t.Number(),
    MinClients: universal_1.t.Number(),
    MinStaff: universal_1.t.Number(),
    Name: universal_1.t.String(),
    ServiceType: universal_1.t.Number(),
    ShiftTag: universal_1.t.Number(),
    Start: universal_1.t.String(),
});
exports.ClientGroupT = universal_1.t.Object({
    Code: universal_1.t.String(),
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
});
exports.ClientLeaveT = universal_1.t.Object({
    Client: universal_1.t.Number(),
    End: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    RawID: universal_1.t.Number(),
    Reason: universal_1.t.String(),
    Start: (0, dates_1.DateObjT)(),
});
exports.ClientT = universal_1.t.Object({
    Active: universal_1.tBoolT,
    Address: universal_1.t.String(),
    AddressKey: universal_1.t.Number(),
    AddressNote: universal_1.t.String(),
    Admission: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Area: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ContactKey: universal_1.t.Number(),
    DOB: universal_1.t.String(),
    Email: (0, universal_1.MaybeT)(universal_1.t.String()),
    EndDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    Facility: (0, universal_1.MaybeT)(universal_1.t.Number()),
    FacilityName: universal_1.t.String(),
    FirstName: universal_1.t.String(),
    FGiven: universal_1.t.String(),
    FullName: universal_1.t.String(),
    Gender: universal_1.t.Union([universal_1.t.Literal('M'), universal_1.t.Literal('F'), universal_1.t.Literal('O')]),
    Group: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ID: universal_1.t.Number(),
    Locale: universal_1.t.String(),
    Location: (0, universal_1.MaybeT)(universal_1.t.Number()),
    MigrationKey: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Note: universal_1.t.String(),
    NotePrivate: universal_1.t.String(),
    Phone: universal_1.t.String(),
    PostCode: universal_1.t.Number(),
    PrefName: (0, universal_1.MaybeT)(universal_1.t.String()),
    Program: (0, universal_1.MaybeT)(universal_1.t.Number()),
    SelfBilling: universal_1.tBoolT,
    StartDate: (0, dates_1.DateObjT)(),
    State: universal_1.StateStringT,
    Surname: universal_1.t.String(),
    Title: universal_1.t.String(),
});
exports.ClockingT = universal_1.t.Object({
    Assignment: (0, universal_1.MaybeT)(universal_1.t.Number()),
    CovidVerified: (0, universal_1.MaybeT)(universal_1.tBoolT),
    Emp: universal_1.t.String(),
    Endpoint: (0, universal_1.MaybeT)(universal_1.tBoolT),
    ID: universal_1.t.Number(),
    IsAuth: (0, universal_1.MaybeT)(universal_1.tBoolT),
    Latitude: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Longitude: (0, universal_1.MaybeT)(universal_1.t.Number()),
    PhKey: (0, universal_1.MaybeT)(universal_1.t.String()),
    SerialNumber: (0, universal_1.MaybeT)(universal_1.t.String()),
    TS: (0, dates_1.DateTimeObjT)(),
    Temperature: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Type: (0, universal_1.MaybeT)(universal_1.t.Number()),
});
exports.CompanyT = universal_1.t.Object({
    Active: universal_1.t.Boolean(),
    Address: universal_1.t.String(),
    City: universal_1.t.String(),
    Code: universal_1.t.String(),
    ID: universal_1.t.Number(),
    MainCo: universal_1.tBoolT,
    Name: universal_1.t.String(),
    Phone: universal_1.t.String(),
    PostCode: universal_1.t.Number(),
    State: universal_1.StateStringT,
});
exports.CompatibilityT = universal_1.t.Object({
    Client: universal_1.t.Number(),
    Compatibility: universal_1.t.Number(),
    Employee: universal_1.t.Number(),
    ID: universal_1.t.Number(),
});
exports.AttributeT = universal_1.t.Object({
    Code: universal_1.t.String(),
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
});
exports.AttributePosT = universal_1.t.Object({
    Classification: universal_1.t.Number(),
    Competency: universal_1.t.Number(),
    Employee: universal_1.t.Number(),
    ID: universal_1.t.Number(),
});
exports.AttributeRequirementT = universal_1.t.Object({
    Client: universal_1.t.Number(),
    Competency: universal_1.t.Number(),
    Compulsory: universal_1.tBoolT,
    ID: universal_1.t.Number(),
    IsCert: universal_1.tBoolT,
    ServiceType: (0, universal_1.MaybeT)(universal_1.t.Number()),
});
exports.CostCentreT = universal_1.t.Object({
    Code: (0, universal_1.MaybeT)(universal_1.t.String()),
    ID: universal_1.t.Number(),
    Leaf: universal_1.t.Boolean(),
    Name: universal_1.t.String(),
    Parent: (0, universal_1.MaybeT)(universal_1.t.Number()),
});
exports.DeletedShiftT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    ShiftAssignment: universal_1.t.Number(),
    Shift: universal_1.t.Number(),
    Roster: universal_1.t.Number(),
    Job: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Start: universal_1.t.String(),
    Finish: universal_1.t.String(),
    Hours: universal_1.t.Number(),
    Day: universal_1.t.Number(),
    Leave: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Qualifier: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Notes: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    Service: (0, universal_1.MaybeT)(universal_1.t.Number()),
    EnteredStart: (0, universal_1.MaybeT)(universal_1.t.String()),
    EnteredFinish: (0, universal_1.MaybeT)(universal_1.t.String()),
    Cancelled: universal_1.t.Union([universal_1.t.Literal(0), universal_1.t.Literal(1), universal_1.t.Literal(2)]),
    TS: universal_1.t.String(),
    User: universal_1.t.String(),
});
exports.EmployeeDetailT = universal_1.t.Object({
    FluVaccineDate: (0, universal_1.MaybeT)(universal_1.t.String()),
    ID: universal_1.t.Number(),
    LicenceExpiryDate: (0, universal_1.MaybeT)(universal_1.t.String()),
    LicenceNumber: (0, universal_1.MaybeT)(universal_1.t.String()),
    LicenceType: (0, universal_1.MaybeT)(universal_1.t.String()),
    MedicareExpiryDate: (0, universal_1.MaybeT)(universal_1.t.String()),
    MedicareNo: (0, universal_1.MaybeT)(universal_1.t.String()),
    Photo: (0, universal_1.MaybeT)(universal_1.t.String()),
});
exports.TCLinkT = universal_1.t.Object({
    Emp: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    SN: (0, universal_1.MaybeT)(universal_1.t.String()),
    TID: universal_1.t.String(),
});
exports.EmployeeT = universal_1.t.Object({
    Active: universal_1.tBoolT,
    ChildrenCheckDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    ChildrenExpiryDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    ChildrenRefNo: (0, universal_1.MaybeT)(universal_1.t.String()),
    City: universal_1.t.String(),
    CommDate: (0, dates_1.DateObjT)(),
    Company: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Competencies: (0, universal_1.MaybeT)(universal_1.t.Array(exports.EmployeeCompetencyT)),
    CovidVaccDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    DOB: (0, dates_1.DateObjT)(),
    DeclarationDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    Deletable: universal_1.tBoolT,
    Email: (0, universal_1.MaybeT)(universal_1.t.String({ format: 'email' })),
    EmailPayslips: universal_1.tBoolT,
    EmergencyName: (0, universal_1.MaybeT)(universal_1.t.String()),
    EmergencyPhone: (0, universal_1.MaybeT)(universal_1.t.String()),
    EndDate: universal_1.t.Optional((0, universal_1.MaybeT)((0, dates_1.DateObjT)())),
    FirstName: universal_1.t.String(),
    FirstNameFormal: universal_1.t.String(),
    FluVaccineDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    FullName: universal_1.t.String(),
    ID: universal_1.t.Number(),
    IgnoreClockings: universal_1.tBoolT,
    InFilter: universal_1.tBoolT,
    IsAgency: universal_1.tBoolT,
    LicenceExpiryDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    LicenceNumber: (0, universal_1.MaybeT)(universal_1.t.String()),
    LicenceType: (0, universal_1.MaybeT)(universal_1.t.String()),
    MedicareExpiryDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    MedicareNo: (0, universal_1.MaybeT)(universal_1.t.String()),
    Mobile: (0, universal_1.MaybeT)(universal_1.t.String()),
    NurseExpiryDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    NurseRefNo: (0, universal_1.MaybeT)(universal_1.t.String()),
    Person: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Phone: (0, universal_1.MaybeT)(universal_1.t.String()),
    Photo: (0, universal_1.MaybeT)(universal_1.t.String()),
    PoliceCheckDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    PoliceConvictions: (0, universal_1.MaybeT)(universal_1.t.Union([universal_1.t.Literal(0), universal_1.t.Literal(1), universal_1.t.Literal(2)])),
    PoliceExpiryDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    PoliceRefNo: (0, universal_1.MaybeT)(universal_1.t.String()),
    PostCode: (0, universal_1.MaybeT)(universal_1.t.Number()),
    PrefName: (0, universal_1.MaybeT)(universal_1.t.String()),
    SecondCovidVaccDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    Sex: universal_1.t.Union([universal_1.t.Literal('M'), universal_1.t.Literal('F'), universal_1.t.Literal('O')]),
    State: universal_1.StateStringT,
    Street: universal_1.t.String(),
    Surname: universal_1.t.String(),
    TCLinks: universal_1.t.Array(exports.TCLinkT),
    VisaCheckDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    VisaExpiryDate: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    VisaIDCheck: (0, universal_1.MaybeT)(universal_1.tBoolT),
    VisaRefNo: (0, universal_1.MaybeT)(universal_1.t.String()),
    VisaType: (0, universal_1.MaybeT)(universal_1.t.Union([universal_1.t.Literal(0), universal_1.t.Literal(1), universal_1.t.Literal(2), universal_1.t.Literal(3)])),
});
exports.EmployeeCertificationT = universal_1.t.Object({
    Certification: universal_1.t.Number(),
    Date: (0, dates_1.DateObjT)(),
    ExpiryDate: (0, dates_1.DateObjT)(),
    Notes: universal_1.t.String(),
    Reference: universal_1.t.String(),
});
class GridExceptions {
    services;
    shifts;
    shiftGaps;
    static schema = universal_1.t.Object({
        services: universal_1.t.Readonly(universal_1.t.Record(universal_1.t.Number(), universal_1.t.Array(universal_1.t.String()))),
        shifts: universal_1.t.Readonly(universal_1.t.Record(universal_1.t.Number(), universal_1.t.Array(universal_1.t.String()))),
        shiftGaps: universal_1.t.Readonly(universal_1.t.Record(universal_1.t.Number(), universal_1.t.Array(universal_1.t.String()))),
        addService: universal_1.t.Function([universal_1.t.Number(), universal_1.t.String()], universal_1.t.Void()),
        addShift: universal_1.t.Function([universal_1.t.Number(), universal_1.t.String()], universal_1.t.Void()),
        addShiftGap: universal_1.t.Function([universal_1.t.Number(), universal_1.t.String()], universal_1.t.Void()),
    });
    constructor() {
        this.services = {};
        this.shiftGaps = {};
        this.shifts = {};
    }
    add(index, key, exception) {
        const obj = this[index][key];
        if (obj) {
            obj.add(exception);
        }
        else {
            this[index][key] = new Set([exception]);
        }
    }
    addService(key, exception) {
        this.add('services', key, exception);
    }
    addShift(key, exception) {
        this.add('shifts', key, exception);
    }
    addShiftGap(key, exception) {
        this.add('shiftGaps', key, exception);
    }
}
exports.GridExceptions = GridExceptions;
exports.IgnoredUnavailabilityT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Date: (0, dates_1.DateObjT)(),
    User: universal_1.t.String(),
});
exports.JobT = universal_1.t.Object({
    Active: universal_1.tBoolT,
    CC: universal_1.t.Array(universal_1.t.Number()),
    Classification: universal_1.t.Number(),
    Company: universal_1.t.Number(),
    ContractHours: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ContractHoursMax: (0, universal_1.MaybeT)(universal_1.t.Number()),
    DefaultArea: (0, universal_1.MaybeT)(universal_1.t.Number()),
    DynamicCC: universal_1.tBoolT,
    Employee: universal_1.t.Number(),
    EndDate: universal_1.t.Optional((0, universal_1.MaybeT)((0, dates_1.DateObjT)())),
    ID: universal_1.t.Number(),
    IsDefault: universal_1.tBoolT,
    LegacyKey: (0, universal_1.MaybeT)(universal_1.t.Number()),
    PHBR: universal_1.tBoolT,
    PayType: exports.JobPayTypeT,
    StartDate: (0, dates_1.DateObjT)(),
    WorkType: universal_1.t.Union([universal_1.t.Literal('P'), universal_1.t.Literal('C'), universal_1.t.Literal('F')]),
});
exports.LeaveT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    Code: universal_1.t.String(),
    ShortName: universal_1.t.String(),
    Casual: universal_1.tBoolT,
    Enabled: universal_1.tBoolT,
    Transferred: universal_1.tBoolT,
    Costed: universal_1.tBoolT,
    PayrollCategory: universal_1.t.String(),
    PrivacyName: universal_1.t.String(),
});
exports.LinkedRosterT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    MasterRoster: universal_1.t.Number(),
    LinkedRoster: universal_1.t.Number(),
    SubRoster: universal_1.t.Number(),
});
exports.SubRosterMasterT = universal_1.t.Object({
    Key: universal_1.t.Number(),
    Name: universal_1.t.String(),
    Rosters: universal_1.t.Array(universal_1.t.Object({ ID: universal_1.t.Number(), Name: universal_1.t.String() })),
});
exports.MetaSettingT = universal_1.t.Object({
    Description: universal_1.t.String(),
    Hidden: universal_1.t.Boolean(),
    Name: universal_1.t.String(),
    Type: universal_1.t.String(),
    Value: universal_1.t.Any(),
});
exports.MetaT = universal_1.t.Object({
    CompanyName: universal_1.t.String(),
    DefaultActual: universal_1.tBoolT,
    Facility: universal_1.t.Number(),
    HasBilling: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    IsCDC: universal_1.t.Boolean(),
    IsLive: universal_1.t.Boolean(),
    LastRecalc: (0, universal_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    LastRecalcLong: (0, universal_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    Name: universal_1.t.String(),
    PayrollVersion: universal_1.t.String(),
    Settings: universal_1.t.Record(universal_1.t.String(), exports.MetaSettingT),
    SharedClockings: universal_1.tBoolT,
    SubBilling: (0, universal_1.MaybeT)(universal_1.t.Number()),
    SubRoster: universal_1.t.Number(),
    SysVals: universal_1.t.Object({
        SchemaDate: (0, dates_1.DateObjT)(),
        CDCMaxGap: (0, universal_1.MaybeT)(universal_1.t.Number()),
    }),
    SubRosterMasters: (0, universal_1.MaybeT)((0, universal_1.ModelTypeT)(exports.SubRosterMasterT)),
});
var NoteEntityType;
(function (NoteEntityType) {
    NoteEntityType[NoteEntityType["Roster"] = 0] = "Roster";
    NoteEntityType[NoteEntityType["Shift"] = 1] = "Shift";
    NoteEntityType[NoteEntityType["Service"] = 2] = "Service";
    NoteEntityType[NoteEntityType["Employee"] = 3] = "Employee";
    NoteEntityType[NoteEntityType["Client"] = 4] = "Client";
    NoteEntityType[NoteEntityType["ServiceSchedule"] = 5] = "ServiceSchedule";
})(NoteEntityType || (exports.NoteEntityType = NoteEntityType = {}));
exports.NoteEntityTypeT = universal_1.t.Enum(NoteEntityType);
exports.NoteT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    ArchivedBy: universal_1.t.Number(),
    ArchivedTime: (0, dates_1.DateTimeObjT)(),
    Author: universal_1.t.String(),
    CreatedBy: universal_1.t.String(),
    Deleted: universal_1.tBoolT,
    DeletedTime: (0, dates_1.DateTimeObjT)(),
    Text: universal_1.t.String(),
    Title: universal_1.t.String(),
    CreationTime: (0, dates_1.DateTimeObjT)(),
    EntityType: (0, universal_1.MaybeT)(exports.NoteEntityTypeT),
    EntityID: universal_1.t.Number(),
    EmployeeViewable: universal_1.tBoolT,
    Priority: universal_1.tBoolT,
    NoteType: universal_1.t.Number(),
});
exports.NoteTypeT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
});
exports.PendingUnavailabilityT = universal_1.t.Object({
    Approved: universal_1.t.Literal(false),
    DateEnd: universal_1.t.String(),
    DateStart: universal_1.t.String(),
    Employee: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    Notes: universal_1.t.String(),
    Recurring: universal_1.t.Union([universal_1.t.Literal(1), universal_1.t.Literal(7), universal_1.t.Literal(14)]),
    Start: universal_1.t.String(),
    Stop: universal_1.t.String(),
});
exports.CurrentPeriodT = universal_1.t.Object({
    Length: universal_1.t.Number(),
    Master: universal_1.t.Boolean(),
    Start: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
});
exports.PeriodT = universal_1.t.Object({
    End: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    ID: universal_1.t.Number(),
    Name: (0, universal_1.MaybeT)(universal_1.t.String()),
    Run: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Start: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
});
exports.PlaceT = universal_1.t.Object({
    Address: universal_1.t.String(),
    ID: universal_1.t.Number(),
    Locale: universal_1.t.String(),
    Name: universal_1.t.String(),
    PostCode: universal_1.t.String({ maxLength: 4, pattern: '[0-9][0-9][0-9][0-9]' }),
    State: universal_1.StateStringT,
});
exports.ProgramT = universal_1.t.Object({
    Code: universal_1.t.String(),
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
});
exports.QualifierT = universal_1.t.Object({
    Casual: universal_1.tBoolT,
    Code: universal_1.t.String(),
    Enabled: universal_1.tBoolT,
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    PayrollShiftType: universal_1.t.Number(),
});
exports.QFRExceptionT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Key: universal_1.t.String(),
    Classification: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Job: (0, universal_1.MaybeT)(universal_1.t.Number()),
    QFRGroup: universal_1.t.Number(),
    Split: universal_1.t.Number(),
    IgnoreAreas: universal_1.tBoolT,
});
exports.QFRSettingBaseT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Areas: universal_1.t.Array(universal_1.t.Number()),
    Classifications: universal_1.t.Array(universal_1.t.Number()),
    DisplayName: universal_1.t.String(),
    Key: universal_1.t.String(),
    Multiplier: universal_1.t.Number(),
    Parent: (0, universal_1.MaybeT)(universal_1.t.Number()),
    RequiredMinutes: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Exceptions: universal_1.t.Array(exports.QFRExceptionT),
});
exports.QFRSettingsKeysT = universal_1.t.Union([
    universal_1.t.Literal('directCare'),
    universal_1.t.Literal('alliedHealth'),
    universal_1.t.Literal('catering'),
]);
exports.QFRDirectCareKeysT = universal_1.t.Union([
    universal_1.t.Literal('registeredNurses'),
    universal_1.t.Literal('enrolledNurses'),
    universal_1.t.Literal('personalCare'),
    universal_1.t.Literal('careManagement'),
]);
exports.QFRAlliedHealthKeysT = universal_1.t.Union([
    universal_1.t.Literal('physiotherapist'),
    universal_1.t.Literal('occupationalTherapist'),
    universal_1.t.Literal('speechPathologist'),
    universal_1.t.Literal('podiatrist'),
    universal_1.t.Literal('dietetic'),
    universal_1.t.Literal('other'),
    universal_1.t.Literal('assistants'),
    universal_1.t.Literal('lifestyle'),
]);
exports.QFRCateringKeysT = universal_1.t.Union([
    universal_1.t.Literal('cooks'),
    universal_1.t.Literal('kitchenAssistants'),
]);
const QFRDirectCareT = universal_1.t.Record(universal_1.t.Literal('direcCare'), universal_1.t.Record(exports.QFRDirectCareKeysT, exports.QFRSettingBaseT));
const QFRAlliedHealthT = universal_1.t.Record(universal_1.t.Literal('alliedHealth'), universal_1.t.Record(exports.QFRAlliedHealthKeysT, exports.QFRSettingBaseT));
const QFRCateringT = universal_1.t.Record(universal_1.t.Literal('catering'), universal_1.t.Record(exports.QFRCateringKeysT, exports.QFRSettingBaseT));
exports.QFRDynamicFieldT = universal_1.t.Record(universal_1.t.String(), universal_1.t.Record(universal_1.t.String(), exports.QFRSettingBaseT));
exports.QFRSettingsT = universal_1.t.Intersect([
    QFRDirectCareT,
    QFRAlliedHealthT,
    QFRCateringT,
    exports.QFRDynamicFieldT,
]);
exports.ResidentAdmissionRosterT = universal_1.t.Object({
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, universal_1.MaybeT)(universal_1.t.String()),
});
exports.RosterClientT = universal_1.t.Object({
    Client: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    Roster: universal_1.t.Number(),
});
exports.RosterEmployeeT = universal_1.t.Object({
    Certifications: (0, universal_1.ModelTypeT)(exports.EmployeeCertificationT),
    Description: universal_1.t.String(),
    FluVacDate: (0, universal_1.MaybeT)(universal_1.t.String()),
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    PoliceExpiryDate: (0, universal_1.MaybeT)(universal_1.t.String()),
    TCID: (0, universal_1.MaybeT)(universal_1.t.String()),
});
exports.RosterJobT = universal_1.t.Object({
    Allowances: universal_1.t.Record(universal_1.t.Number(), universal_1.t.Object({
        Units: universal_1.t.Number(),
        Cost: universal_1.t.Number(),
    })),
    ID: universal_1.t.Number(),
    Job: universal_1.t.Number(),
    Roster: universal_1.t.Number(),
});
exports.RosterT = universal_1.t.Object({
    End: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    ID: universal_1.t.Number(),
    Name: (0, universal_1.MaybeT)(universal_1.t.String()),
    PayPeriod: (0, universal_1.MaybeT)(universal_1.t.Number()),
    PayrollState: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Run: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Start: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    State: universal_1.t.Number(),
});
exports.SCHADSGroupT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Color: universal_1.t.String(),
});
exports.ScheduledLeaveT = universal_1.t.Object({
    Application: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Finish: (0, dates_1.DateObjT)(),
    ScheduledID: universal_1.t.Number(),
    Start: (0, dates_1.DateObjT)(),
    Type: universal_1.t.String(),
});
exports.ServiceT = universal_1.t.Object({
    Cancelled: (0, universal_1.MaybeT)(universal_1.tBoolT),
    CancelType: (0, universal_1.MaybeT)(exports.ServiceCancellationTypeT),
    Changed: (0, universal_1.MaybeT)(universal_1.tBoolT),
    ChangedVerified: (0, universal_1.MaybeT)(universal_1.tBoolT),
    Client: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Day: (0, universal_1.MaybeT)(exports.DayNumbersT),
    Date: (0, universal_1.MaybeT)(universal_1.t.String()),
    Event: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ID: universal_1.t.Number(),
    NDISCode: (0, universal_1.MaybeT)(universal_1.t.String()),
    Notes: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    PlaceStart: (0, universal_1.MaybeT)(universal_1.t.Number()),
    PlaceStop: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Reference: (0, universal_1.MaybeT)(universal_1.t.String()),
    RequestContact: (0, universal_1.MaybeT)(universal_1.t.Number()),
    RequestDate: (0, universal_1.MaybeT)(universal_1.t.String()),
    RequestedBy: (0, universal_1.MaybeT)(universal_1.t.String()),
    RequiredStaff: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Roster: (0, universal_1.MaybeT)(universal_1.t.Number()),
    RosterClient: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ScheduledKey: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ScheduleUnlinked: universal_1.tBoolT,
    ServiceType: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Shifts: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    ShiftsCancelled: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    Start: universal_1.t.String(),
    Stop: universal_1.t.String(),
    Type: (0, universal_1.MaybeT)(universal_1.t.Number()),
    VerifiedBy: (0, universal_1.MaybeT)(universal_1.t.String()),
    VerifiedStart: (0, universal_1.MaybeT)(universal_1.t.String()),
    VerifiedStop: (0, universal_1.MaybeT)(universal_1.t.String()),
});
exports.ServiceTypeAllowanceT = universal_1.t.Object({
    AllowanceType: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    IgnoreHours: universal_1.tBoolT,
    ServiceType: universal_1.t.Number(),
});
exports.ServiceTypeT = universal_1.t.Object({
    ChargeGroup: universal_1.t.Number(),
    Code: universal_1.t.String(),
    Color: universal_1.t.String(),
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    Active: universal_1.tBoolT,
});
exports.ServiceCancellationT = universal_1.t.Object({
    Service: universal_1.t.Number(),
    Note: universal_1.t.String(),
    CancelledBy: universal_1.t.String(),
    Client: universal_1.t.Number(),
    ServiceTS: (0, dates_1.DateObjT)(),
    Actioned: universal_1.tBoolT,
    ActionedBy: (0, universal_1.MaybeT)(universal_1.t.String()),
});
exports.ServiceFeedbackT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    Service: universal_1.t.Number(),
    WasPositive: universal_1.tBoolT,
    Note: universal_1.t.String(),
    Photo: universal_1.t.String(),
    User: universal_1.t.String(),
    SubmissionDate: universal_1.t.String(),
    Actioned: universal_1.tBoolT,
    ActionedBy: (0, universal_1.MaybeT)(universal_1.t.String()),
    ActionedDate: (0, universal_1.MaybeT)(universal_1.t.String()),
    Response: universal_1.t.String(),
});
exports.ServiceRequestT = universal_1.t.Object({
    Client: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    RequestedBy: universal_1.t.String(),
    RequestTime: universal_1.t.String(),
    Note: universal_1.t.String(),
    Actioned: universal_1.tBoolT,
    ActionedBy: (0, universal_1.MaybeT)(universal_1.t.String()),
    ResponseNote: universal_1.t.String(),
});
exports.ServiceScheduledT = universal_1.t.Object({
    BreakCycle: universal_1.t.Number(),
    Client: universal_1.t.Number(),
    Created: (0, dates_1.DateObjT)(),
    CreatedBy: (0, universal_1.MaybeT)(universal_1.t.String()),
    DateEnd: (0, universal_1.MaybeT)(universal_1.t.String()),
    DateStart: universal_1.t.String(),
    ID: universal_1.t.Number(),
    Job: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Reference: (0, universal_1.MaybeT)(universal_1.t.String()),
    NDISCode: universal_1.t.String(),
    RequestContact: (0, universal_1.MaybeT)(universal_1.t.String()),
    RequestDate: (0, universal_1.MaybeT)(universal_1.t.String()),
    RequestedBy: (0, universal_1.MaybeT)(universal_1.t.String()),
    RequiredStaff: universal_1.t.Number(),
    ServiceType: universal_1.t.Number(),
    Start: universal_1.t.String(),
    Stop: universal_1.t.String(),
    Updated: universal_1.t.String(),
    WeekCycle: universal_1.t.Union([
        universal_1.t.Literal(1),
        universal_1.t.Literal(2),
        universal_1.t.Literal(3),
        universal_1.t.Literal(4),
        universal_1.t.Literal(5),
        universal_1.t.Literal(7),
    ]),
    WeekCycleMultiplier: universal_1.t.Number(),
    Weekdays: universal_1.t.String(),
    ScheduleNote: universal_1.t.String(),
    ServiceNote: universal_1.t.String(),
    ServiceNotePrivate: universal_1.t.String(),
});
exports.ServiceScheduleLogT = universal_1.t.Intersect([
    exports.ServiceScheduledT,
    universal_1.t.Object({
        ScheduleID: universal_1.t.Number(),
        EditedBy: universal_1.t.String(),
    }),
]);
exports.ShiftGapT = universal_1.t.Object({
    ID: universal_1.t.Number(),
    ShiftAfter: universal_1.t.Number(),
    ShiftBefore: universal_1.t.Number(),
    TravelKM: universal_1.t.Number(),
    TravelMinutes: universal_1.t.Number(),
    IsAllowanceGap: universal_1.tBoolT,
    AdjustedManually: universal_1.tBoolT,
});
exports.ShiftQueryT = universal_1.t.Object({
    Employee: universal_1.t.Number(),
    Timestamp: (0, dates_1.DateTimeObjT)(),
});
exports.ShiftTagT = universal_1.t.Object({
    Code: universal_1.t.String(),
    Color: universal_1.t.String(),
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    Priority: universal_1.tBoolT,
});
exports.ShiftLocationT = universal_1.t.Object({
    Assignment: universal_1.t.Number(),
    IsStart: universal_1.tBoolT,
    Latitude: universal_1.t.Number(),
    Longitude: universal_1.t.Number(),
    Accuracy: universal_1.t.Number(),
});
exports.ShiftT = universal_1.t.Object({
    Allowances: (0, universal_1.ModelTypeT)(universal_1.t.Object({
        Cost: universal_1.t.Number(),
        ID: universal_1.t.Number(),
        Units: universal_1.t.Number(),
    })),
    ActualStart: (0, universal_1.MaybeT)(universal_1.t.String()),
    ActualFinish: (0, universal_1.MaybeT)(universal_1.t.String()),
    Area: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Cancelled: (0, universal_1.MaybeT)(exports.ShiftCancellationTypeT),
    CanonFinish: (0, universal_1.MaybeT)(universal_1.t.String()),
    CanonStart: (0, universal_1.MaybeT)(universal_1.t.String()),
    Classification: universal_1.t.Number(),
    ClockStart: universal_1.t.Number(),
    ClockFinish: universal_1.t.Number(),
    CostAllow: (0, universal_1.MaybeT)(universal_1.t.Number()),
    CostHour: (0, universal_1.MaybeT)(universal_1.t.Number()),
    CostMultiplier: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Date: universal_1.t.Optional((0, universal_1.MaybeT)((0, dates_1.DateObjT)())),
    Day: universal_1.t.Number(),
    EmployeeChanged: universal_1.tBoolT,
    EnteredFinish: (0, universal_1.MaybeT)(universal_1.t.String()),
    EnteredStart: (0, universal_1.MaybeT)(universal_1.t.String()),
    Event: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Finish: universal_1.t.String(),
    FinishLocation: (0, universal_1.MaybeT)(exports.ShiftLocationT),
    Hours: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    IncidentalApproved: universal_1.tBoolT,
    IncidentalCharge: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Job: (0, universal_1.MaybeT)(universal_1.t.Number()),
    KmAllowance: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Leave: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Notes: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    PaidFinish: (0, universal_1.MaybeT)(universal_1.t.String()),
    PaidStart: (0, universal_1.MaybeT)(universal_1.t.String()),
    PayrollShiftType: universal_1.t.Number(),
    Qualifier: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Roster: universal_1.t.Number(),
    RosterJob: universal_1.t.Number(),
    Service: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ServiceCancelled: (0, universal_1.MaybeT)(universal_1.t.Number()),
    Shift: universal_1.t.Number(),
    Start: universal_1.t.String(),
    StartLocation: (0, universal_1.MaybeT)(exports.ShiftLocationT),
    Tags: universal_1.t.Array(universal_1.t.Number()),
    Template: universal_1.t.String(),
    Verified: universal_1.tBoolT,
    VerifyTime: (0, universal_1.MaybeT)(universal_1.t.String()),
    VerifyUser: (0, universal_1.MaybeT)(universal_1.t.String()),
    Warnings: universal_1.t.Array(universal_1.t.Number()),
});
exports.SMST = universal_1.t.Object({
    Delivered: universal_1.tBoolT,
    Employee: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    Message: universal_1.t.String(),
    MobileNo: universal_1.t.String(),
    Response: universal_1.t.String(),
    ResponseTime: universal_1.t.String(),
    SMSThreadKey: universal_1.t.String(),
    Thread: universal_1.t.Number(),
});
exports.SMSAssignT = universal_1.t.Object({
    Assignment: universal_1.t.Number(),
    AutoAccept: universal_1.tBoolT,
    AutoRespond: universal_1.tBoolT,
    Closed: universal_1.t.String(),
    Created: universal_1.t.String(),
    Employees: universal_1.t.Array(exports.SMST),
    ID: universal_1.t.Number(),
    Service: (0, universal_1.MaybeT)(universal_1.t.Number()),
    WinningEmployee: universal_1.t.Number(),
});
exports.SMSHistoryT = universal_1.t.Object({
    Delivered: universal_1.t.String(),
    ID: universal_1.t.Number(),
    IsIncoming: universal_1.tBoolT,
    Message: universal_1.t.String(),
    Mobile: universal_1.t.String(),
    SenderUsername: universal_1.t.String(),
    Timestamp: universal_1.t.String(),
});
exports.TemplateT = universal_1.t.Object({
    Code: universal_1.t.String(),
    Color: (0, universal_1.MaybeT)(universal_1.t.String()),
    Finish: universal_1.t.String(),
    Hours: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    Start: universal_1.t.String(),
});
exports.TimeClockSerialT = universal_1.t.Object({
    Name: universal_1.t.String(),
    Serial: universal_1.t.String(),
});
exports.UnavailabilityBlockT = universal_1.t.Object({
    Day: universal_1.t.Number(),
    Employee: universal_1.t.Number(),
    ID: universal_1.t.Number(),
    Start: universal_1.t.String(),
    Stop: universal_1.t.String(),
});
exports.UnavailabilityRecordT = universal_1.t.Object({
    Approved: universal_1.tBoolT,
    DateEnd: (0, universal_1.MaybeT)((0, dates_1.DateObjT)()),
    DateStart: (0, dates_1.DateObjT)(),
    Employee: universal_1.t.Number(),
    EmployeeRequested: universal_1.tBoolT,
    ID: universal_1.t.Number(),
    Notes: universal_1.t.String(),
    Recurring: (0, universal_1.MaybeT)(universal_1.t.Union([universal_1.t.Literal(1), universal_1.t.Literal(7), universal_1.t.Literal(14)])),
    Start: universal_1.t.String(),
    Stop: universal_1.t.String(),
});
exports.UnavailabilityModelT = universal_1.t.Object({
    Blocks: universal_1.t.Array(exports.UnavailabilityBlockT),
    Records: (0, universal_1.ModelTypeT)(exports.UnavailabilityRecordT),
    UBE: (0, universal_1.ModelTypeT)(universal_1.t.Object({
        Blocks: universal_1.t.Array(exports.UnavailabilityBlockT),
        ID: universal_1.t.Number(),
        Rows: universal_1.t.Array(universal_1.t.Any()),
    })),
});
exports.UnavailabilityPresetT = universal_1.t.Object({
    End: universal_1.t.String(),
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    Start: universal_1.t.String(),
});
exports.VerificationT = universal_1.t.Object({
    Assignment: universal_1.t.Number(),
    ClockFinish: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ClockStart: (0, universal_1.MaybeT)(universal_1.t.Number()),
    OriginalFinish: universal_1.t.String(),
    OriginalHours: universal_1.t.Number(),
    OriginalStart: universal_1.t.String(),
    VerifyNote: universal_1.t.String(),
    VerifyTime: universal_1.t.String(),
    VerifyUser: universal_1.t.String(),
});
exports.WarningT = universal_1.t.Object({
    Description: universal_1.t.String(),
    ID: universal_1.t.Number(),
    Name: universal_1.t.String(),
    Type: universal_1.t.Union([universal_1.t.Literal(1), universal_1.t.Literal(2), universal_1.t.Literal(3)]),
});
exports.TakenT = universal_1.t.Object({
    RosterAuth: universal_1.t.Number(),
    addresses: universal_1.t.Number(),
    allowTypes: universal_1.t.Number(),
    allowances: universal_1.t.Number(),
    areas: universal_1.t.Number(),
    billingLocations: universal_1.t.Number(),
    cccFilter: universal_1.t.Number(),
    chargeGroups: universal_1.t.Number(),
    classifications: universal_1.t.Number(),
    clientEvents: universal_1.t.Number(),
    clientGroups: universal_1.t.Number(),
    clientJobCount: universal_1.t.Number(),
    clientLeave: universal_1.t.Number(),
    clients: universal_1.t.Number(),
    clockings: universal_1.t.Number(),
    companies: universal_1.t.Number(),
    compatibilities: universal_1.t.Number(),
    competencies: universal_1.t.Number(),
    competencyPos: universal_1.t.Number(),
    competencyReq: universal_1.t.Number(),
    contacts: universal_1.t.Number(),
    costCentres: universal_1.t.Number(),
    employeeDetails: universal_1.t.Number(),
    employeeNotes: universal_1.t.Number(),
    employees: universal_1.t.Number(),
    jobs: universal_1.t.Number(),
    leave: universal_1.t.Number(),
    meta: universal_1.t.Number(),
    notes: universal_1.t.Number(),
    pendingUnavailability: universal_1.t.Number(),
    period: universal_1.t.Number(),
    periods: universal_1.t.Number(),
    places: universal_1.t.Number(),
    programs: universal_1.t.Number(),
    pubHols: universal_1.t.Number(),
    quals: universal_1.t.Number(),
    residentAccounts: universal_1.t.Number(),
    residentAdmissions: universal_1.t.Number(),
    residentContacts: universal_1.t.Number(),
    residentsInWaiting: universal_1.t.Number(),
    rosterClients: universal_1.t.Number(),
    rosterEmployees: universal_1.t.Number(),
    rosterJobs: universal_1.t.Number(),
    rosters: universal_1.t.Number(),
    scheduledLeave: universal_1.t.Number(),
    serviceTypeAllowances: universal_1.t.Number(),
    serviceTypes: universal_1.t.Number(),
    services: universal_1.t.Number(),
    servicesScheduled: universal_1.t.Number(),
    shiftGaps: universal_1.t.Number(),
    shiftQueries: universal_1.t.Number(),
    shiftTags: universal_1.t.Number(),
    shiftToAssignment: universal_1.t.Number(),
    shifts: universal_1.t.Number(),
    shiftsShared: universal_1.t.Number(),
    smsAssign: universal_1.t.Number(),
    smsHistory: universal_1.t.Number(),
    smsNumbersUsed: universal_1.t.Number(),
    templates: universal_1.t.Number(),
    timeClockSerials: universal_1.t.Number(),
    unavailabilityBlocks: universal_1.t.Number(),
    unavailabilityPresets: universal_1.t.Number(),
    verifications: universal_1.t.Number(),
    warnings: universal_1.t.Number(),
});
exports.ViewModelT = universal_1.t.Object({
    clock_tolerances: universal_1.t.Tuple([universal_1.t.Number(), universal_1.t.Number(), universal_1.t.Number(), universal_1.t.Number()]),
    colorBy: exports.ViewColorByT,
    compact: universal_1.t.Boolean(),
    compareMode: universal_1.t.Boolean(),
    days_to_show: universal_1.t.Array(exports.DayNumbersT),
    doubleSpans: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    enable_ghosting: universal_1.t.Boolean(),
    filterAreas: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    filterClassifications: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    filterClientGroups: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    filterCostCentres: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    filterServiceTypes: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    filterServices: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    filterTemplates: (0, universal_1.MaybeT)(universal_1.t.Array(universal_1.t.Number())),
    firstColumnWidth: (0, universal_1.MaybeT)(universal_1.t.Number()),
    ghostShifts: universal_1.t.Boolean(),
    groupingType: exports.ViewGroupByT,
    hideEmpty: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    hideMissingTCIDRows: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    hidePHBR: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    ignoreShiftDuration: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    label_items: universal_1.t.Array(universal_1.t.Number()),
    run: (0, universal_1.MaybeT)(universal_1.t.Number()),
    shift_blips: universal_1.t.Array(universal_1.t.Number()),
    showAgency: universal_1.t.Boolean(),
    showCancelled: universal_1.t.Boolean(),
    showCasual: universal_1.t.Boolean(),
    showEmpJobs: universal_1.t.Boolean(),
    showLeave: universal_1.t.Boolean(),
    showNavSidebar: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    showPermanent: universal_1.t.Boolean(),
    showShiftGaps: universal_1.t.Boolean(),
    showUnassigned: universal_1.t.Boolean(),
    showUnavailability: universal_1.t.Boolean(),
    showUnverified: universal_1.t.Boolean(),
    showVerified: universal_1.t.Boolean(),
    showWorked: universal_1.t.Boolean(),
    structure_label: exports.StructureLabelT,
    structure_shift: exports.StructureShiftT,
    task_items: universal_1.t.Array(universal_1.t.Number()),
    task_tolerances: universal_1.t.Tuple([universal_1.t.Number(), universal_1.t.Number()]),
    total_items: universal_1.t.Array(universal_1.t.Number()),
});
exports.ViewT = universal_1.t.Object({
    Created: universal_1.t.String(),
    Creator: universal_1.t.String(),
    Data: exports.ViewModelT,
    ID: universal_1.t.Number(),
    IsSystemView: universal_1.tBoolT,
    Name: universal_1.t.String(),
});
exports.RosterMetaDataT = universal_1.t.Object({
    HC: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    HCTest: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    buildTimeout: (0, universal_1.MaybeT)(universal_1.t.Number()),
    clipboard: (0, universal_1.MaybeT)(universal_1.t.Object({
        is_copy: universal_1.t.Boolean(),
        items: universal_1.t.Array(universal_1.t.Object({
            key: universal_1.t.Number(),
            elem: universal_1.t.Any(),
            index: universal_1.t.Number(),
        })),
    })),
    enable_dragging: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    enable_editing: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    enable_selection: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    explicit_clocking_matches: (0, universal_1.MaybeT)((0, universal_1.ModelTypeT)(universal_1.t.Tuple([universal_1.t.Number(), universal_1.t.Number()]))),
    firstLoad: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    pathCache: (0, universal_1.MaybeT)(universal_1.t.Any()),
    preset_edit: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    preset_views: (0, universal_1.MaybeT)((0, universal_1.ModelTypeT)(exports.ViewT)),
    prop: (0, universal_1.MaybeT)(universal_1.t.Object({
        Propagate: universal_1.t.Boolean(),
        Rosters: universal_1.t.Array(universal_1.t.Number()),
    })),
    recalcInProgress: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    recalcTimer: (0, universal_1.MaybeT)(universal_1.t.Number()),
    recalcTotalsTimer: (0, universal_1.MaybeT)(universal_1.t.Number()),
    refreshDynamicDataModelNeeded: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    scrollLock: (0, universal_1.MaybeT)(universal_1.t.Boolean()),
    shiftEditing: (0, universal_1.MaybeT)(universal_1.t.Tuple([
        universal_1.t.Any(),
        universal_1.t.Array(exports.ShiftT),
        universal_1.t.Boolean(),
    ])),
    templateSearch: (0, universal_1.MaybeT)(universal_1.t.String()),
    view: (0, universal_1.MaybeT)(exports.ViewModelT),
});
exports.DataModelT = universal_1.t.Object({
    FullRefresh: universal_1.t.String(),
    RosterAuth: universal_1.t.Number(),
    addresses: (0, universal_1.ModelTypeT)(universal_1.AddressCardT),
    allowCriterias: (0, universal_1.ModelTypeT)(exports.AllowCriteriaT),
    allowTypes: (0, universal_1.ModelTypeT)(universal_1.t.Object({ ID: universal_1.t.Number(), Name: universal_1.t.String() })),
    allowances: (0, universal_1.ModelTypeT)(exports.AllowanceT),
    areas: (0, universal_1.ModelTypeT)(exports.AreaT),
    attributes: (0, universal_1.ModelTypeT)(exports.AttributeT),
    attributePos: (0, universal_1.ModelTypeT)(exports.AttributePosT),
    attributeReq: (0, universal_1.ModelTypeT)(exports.AttributeRequirementT),
    billingLocations: (0, universal_1.ModelTypeT)(universal_1.TBill.FacilityLocationT),
    cancellationReasons: (0, universal_1.ModelTypeT)(exports.CancellationReasonT),
    cccFilter: exports.CCCFilterT,
    certifications: (0, universal_1.ModelTypeT)(exports.CertificationT),
    chargeGroups: (0, universal_1.ModelTypeT)(exports.ChargeGroupT),
    classRows: universal_1.t.Array(universal_1.t.Number()),
    classifications: (0, universal_1.ModelTypeT)(exports.ClassificationT),
    clientEvents: (0, universal_1.ModelTypeT)(exports.ClientEventT),
    clientGroups: (0, universal_1.ModelTypeT)(exports.ClientGroupT),
    clientJobCount: (0, universal_1.ModelTypeT)((0, universal_1.ModelTypeT)(universal_1.t.Number())),
    clientLeave: (0, universal_1.ModelTypeT)(universal_1.t.Array(exports.ClientLeaveT)),
    clients: (0, universal_1.ModelTypeT)(exports.ClientT),
    clockings: (0, universal_1.ModelTypeT)(exports.ClockingT),
    companies: (0, universal_1.ModelTypeT)(exports.CompanyT),
    compatibilities: (0, universal_1.ModelTypeT)(exports.CompatibilityT),
    competencies: (0, universal_1.ModelTypeT)(universal_1.THR.CompetencyT),
    competencyClassifications: (0, universal_1.ModelTypeT)(universal_1.THR.CompetencyClassificationT),
    competencyFields: (0, universal_1.ModelTypeT)(universal_1.THR.CompetencyFieldT),
    competencyDropdowns: (0, universal_1.ModelTypeT)(universal_1.THR.CompetencyDropdownT),
    employeeCompetencies: (0, universal_1.ModelTypeT)(universal_1.THR.EmployeeCompetencyT),
    employeeCompetencyFields: (0, universal_1.ModelTypeT)(universal_1.THR.EmployeeCompetencyFieldT),
    employeesToHR: (0, universal_1.ModelTypeT)(universal_1.t.Number()),
    contacts: (0, universal_1.ModelTypeT)(universal_1.ContactCardT),
    costCentres: (0, universal_1.ModelTypeT)(exports.CostCentreT),
    deletedClockings: (0, universal_1.ModelTypeT)(universal_1.t.Object({ Emp: universal_1.t.String(), SerialNumber: universal_1.t.String() })),
    employeeDetails: (0, universal_1.ModelTypeT)(exports.EmployeeDetailT),
    employeeNotes: (0, universal_1.ModelTypeT)(universal_1.t.String()),
    employees: (0, universal_1.ModelTypeT)(exports.EmployeeT),
    facilities: universal_1.t.Any(),
    gridExceptions: GridExceptions.schema,
    hrClassifications: (0, universal_1.ModelTypeT)(universal_1.THR.ClassificationT),
    hrEmployees: (0, universal_1.ModelTypeT)(universal_1.t.Number()),
    ignoredUnavailability: (0, universal_1.ModelTypeT)(universal_1.t.Array(exports.IgnoredUnavailabilityT)),
    jobs: (0, universal_1.ModelTypeT)(exports.JobT),
    leave: (0, universal_1.ModelTypeT)(exports.LeaveT),
    linkedRosters: (0, universal_1.ModelTypeT)(exports.LinkedRosterT),
    meta: exports.MetaT,
    notes: (0, universal_1.ModelTypeT)(exports.NoteT),
    noteTypes: (0, universal_1.ModelTypeT)(exports.NoteTypeT),
    pendingUnavailability: (0, universal_1.ModelTypeT)(exports.PendingUnavailabilityT),
    period: exports.CurrentPeriodT,
    periods: (0, universal_1.ModelTypeT)(exports.PeriodT),
    places: (0, universal_1.ModelTypeT)(exports.PlaceT),
    programs: (0, universal_1.ModelTypeT)(exports.ProgramT),
    pubHols: universal_1.t.Record(universal_1.t.String(), universal_1.t.String()),
    qfrSettings: exports.QFRSettingsT,
    qfrExceptions: (0, universal_1.ModelTypeT)(exports.QFRExceptionT),
    quals: (0, universal_1.ModelTypeT)(exports.QualifierT),
    reqTimers: universal_1.t.Object({
        complete: universal_1.t.Number(),
        pyInner: universal_1.t.Number(),
        pyOuter: universal_1.t.Number(),
        splits: universal_1.t.Array(universal_1.t.Object({ Label: universal_1.t.String(), DurationMs: universal_1.t.Number() })),
    }),
    residentAccounts: (0, universal_1.ModelTypeT)(universal_1.TBill.ResidentAccountT),
    residentAdmissions: (0, universal_1.ModelTypeT)(universal_1.t.Array(exports.ResidentAdmissionRosterT)),
    residentContacts: (0, universal_1.ModelTypeT)(universal_1.TBill.ResidentContactT),
    residentsInWaiting: (0, universal_1.ModelTypeT)(universal_1.t.Any()),
    rosterClients: (0, universal_1.ModelTypeT)(exports.RosterClientT),
    rosterEmployees: (0, universal_1.ModelTypeT)(exports.RosterEmployeeT),
    rosterJobs: (0, universal_1.ModelTypeT)(exports.RosterJobT),
    rosters: (0, universal_1.ModelTypeT)(exports.RosterT),
    schadsGroups: (0, universal_1.ModelTypeT)(exports.SCHADSGroupT),
    scheduledLeave: (0, universal_1.ModelTypeT)(universal_1.t.Array(exports.ScheduledLeaveT)),
    serviceCancellations: (0, universal_1.ModelTypeT)(exports.ServiceCancellationT),
    servicesScheduledLog: (0, universal_1.ModelTypeT)(universal_1.t.Array(exports.ServiceScheduleLogT)),
    serviceFeedback: (0, universal_1.ModelTypeT)(exports.ServiceFeedbackT),
    serviceRequests: (0, universal_1.ModelTypeT)(exports.ServiceRequestT),
    servicesScheduled: (0, universal_1.ModelTypeT)(exports.ServiceScheduledT),
    serviceTypes: (0, universal_1.ModelTypeT)(exports.ServiceTypeT),
    serviceTypeAllowances: (0, universal_1.ModelTypeT)(exports.ServiceTypeAllowanceT),
    services: (0, universal_1.ModelTypeT)(exports.ServiceT),
    shiftGaps: (0, universal_1.ModelTypeT)(exports.ShiftGapT),
    shiftQueries: (0, universal_1.ModelTypeT)(universal_1.t.Array(exports.ShiftQueryT)),
    shiftTags: (0, universal_1.ModelTypeT)(exports.ShiftTagT),
    shiftToAssignment: (0, universal_1.ModelTypeT)(universal_1.t.Array(universal_1.t.Number())),
    shiftToSCHADSGroup: (0, universal_1.ModelTypeT)(universal_1.t.Number()),
    shifts: (0, universal_1.ModelTypeT)(exports.ShiftT),
    shiftsDeleted: (0, universal_1.ModelTypeT)(exports.DeletedShiftT),
    shiftsShared: (0, universal_1.ModelTypeT)(universal_1.t.Array(universal_1.t.Number())),
    smsAssign: (0, universal_1.ModelTypeT)(exports.SMSAssignT),
    smsHistory: (0, universal_1.ModelTypeT)(exports.SMSHistoryT),
    smsNumbersFetched: universal_1.t.Array(universal_1.t.String()),
    smsNumbersUsed: universal_1.t.Array(universal_1.t.String()),
    static: universal_1.t.Any(),
    taken: exports.TakenT,
    templates: (0, universal_1.ModelTypeT)(exports.TemplateT),
    templatesFromTimes: universal_1.t.Record(universal_1.t.String(), universal_1.t.Number()),
    this: universal_1.t.Number(),
    timeClockSerials: (0, universal_1.ModelTypeT)(exports.TimeClockSerialT),
    unavailabilityBlocks: exports.UnavailabilityModelT,
    unavailabilityPresets: (0, universal_1.ModelTypeT)(exports.UnavailabilityPresetT),
    unmatchedClockings: (0, universal_1.ModelTypeT)(universal_1.t.Array(universal_1.t.Number())),
    verifications: (0, universal_1.ModelTypeT)(exports.VerificationT),
    warnings: (0, universal_1.ModelTypeT)(exports.WarningT),
});
exports.ServerDataModelT = universal_1.t.Omit(exports.DataModelT, [
    'FullRefresh',
    'static',
    'classRows',
    'deletedClockings',
    'gridExceptions',
    'allowCriterias',
    'reqTimers',
    'shiftToSCHADSGroup',
    'smsNumbersFetched',
    'taken',
    'templatesFromTimes',
    'unmatchedClockings',
]);
//# sourceMappingURL=types-roster-server.js.map